import script from "./AudienceHeaderSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceHeaderSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceHeaderSkeleton.vue?vue&type=style&index=0&id=463cdc92&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-463cdc92"]])

export default __exports__